import { formatCallerNumber } from '../../modules/telephony/utils/callFormat';

const money = (v) => (v == null ? '' : `${Number(v).toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} грн`);

/** «Ильченко Александр · 097 322 00 44 · 1 250,80 грн · Запоріжжя» */
function describeOrder(o) {
  return [o.clientName, o.phone ? formatCallerNumber(o.phone) : null, money(o.price), o.city].filter(Boolean).join(' · ');
}

/**
 * SSE-подія замовлення prom.ua → сповіщення (in-app тост + desktop). `key` — для дедупу
 * (після реконекту SSE подія не повторюється, але один ключ на подію не завадить).
 * Форма — та сама, що в toastForCallEvent: { key, title, body, line2, target, tone }.
 */
export function toastForPromEvent(event, data) {
  const target = `/telephony/prom-orders/${data.orderId}`;
  switch (event) {
    case 'prom.order.created':
      return data.paid
        ? { key: `prom-created:${data.orderId}`, title: `💳 Оплачене замовлення prom.ua №${data.promId}`, body: describeOrder(data), line2: 'Пром-оплата — відвантажити першим', target, tone: 'success', actionLabel: 'Відкрити замовлення' }
        : { key: `prom-created:${data.orderId}`, title: `🛒 Нове замовлення prom.ua №${data.promId}`, body: describeOrder(data), line2: data.itemsCount ? `Позицій: ${data.itemsCount}` : '', target, tone: 'info', actionLabel: 'Відкрити замовлення' };
    case 'prom.order.paid':
      return {
        key: `prom-paid:${data.orderId}`,
        title: `💳 Оплачено замовлення prom.ua №${data.promId}`,
        body: describeOrder(data),
        line2: data.inquiryNumber ? `Звернення №${data.inquiryNumber} — відвантажити першим` : 'Пром-оплата — відвантажити першим',
        target: data.inquiryId ? `/telephony/inquiries/${data.inquiryId}` : target,
        tone: 'success',
        actionLabel: data.inquiryId ? 'Відкрити звернення' : 'Відкрити замовлення',
      };
    case 'prom.order.canceled':
      return {
        key: `prom-canceled:${data.orderId}`,
        title: `Скасовано замовлення prom.ua №${data.promId}`,
        body: describeOrder(data),
        line2: [data.cancellationTitle, data.inquiryNumber ? `звернення №${data.inquiryNumber}` : null].filter(Boolean).join(' · '),
        target: data.inquiryId ? `/telephony/inquiries/${data.inquiryId}` : target,
        tone: 'warning',
        actionLabel: data.inquiryId ? 'Відкрити звернення' : 'Відкрити замовлення',
      };
    default:
      return null;
  }
}
